import type {ModifiableSchemaReference} from '../types';
import {getSchemaModifiers} from '../functions';

export const useSchemaModifiers = (schemaRef: ModifiableSchemaReference) =>
  getSchemaModifiers(schemaRef);
